import React from "react";

import NeedHelp from '../need-help'

import { getSS } from '../../helpers'

interface SubmitButtonsProps {
  [key: string]: any
}

const SubmitButtons: React.FC<SubmitButtonsProps> = (props:any) => {

  return (
    <>
      <div className="row">
        <div className="submit-buttons clearfix box">
          { getSS('membership').payment_type === 'Single' &&
            <div className="medium-6 columns">
              <button type="submit" className="btn-cta go" id="m-pay-by-card-3-button" onClick={() => props.setFieldValue('payment_method', 'CreditCard')}>Card</button>
              <div className="supported-cards show-for-small">
                <img src="/assets/default/images/supported-cards.png" alt="Supported cards: Visa, Mastercard, Maestro & American Express"/>
              </div>
              <button type="submit" className="btn-cta go" id="m-pay-by-paypal-button" onClick={() => props.setFieldValue('payment_method', 'PayPal')}><span>PayPal</span></button>
              <div className="braintree-logo show-for-small">
                <img src="/assets/default/images/braintree.png" alt="Payments by braintree"/>
              </div>
              <div className="large-12 columns divider show-for-small"></div>
            </div>
          }
          { getSS('membership').payment_type === 'CardReader' &&
            <div className="medium-6 columns">
              <button type="submit" className="btn-cta go" id="m-next-button-3" onClick={() => props.setFieldValue('payment_method', 'CardReader')}>Next</button>
            </div>
          }
          { getSS('membership').payment_type === 'Regular' &&
            <div className="medium-6 columns">
              <button type="submit" className="btn-cta go" id="m-next-button-3" onClick={() => props.setFieldValue('payment_method', 'DirectDebit')}>Next</button>
            </div>
          }
          <div className="medium-6 columns">
            <NeedHelp />
          </div>
          { getSS('membership').payment_type === 'Single' &&
            <>
              <div className="large-12 columns divider hide-for-small"></div>
              <div className="medium-6 columns hide-for-small">
                <div className="supported-cards">
                  <img src="/assets/default/images/supported-cards.png" alt="Supported cards: Visa, Mastercard, Maestro & American Express"/>
                </div>
              </div>
              <div className="medium-6 columns bt-desktop hide-for-small">
                <div className="braintree-logo">
                  <img src="/assets/default/images/braintree.png" alt="Payments by braintree"/>
                </div>
              </div>
            </>
          }
        </div>
      </div>
    </>
  );
};

export default SubmitButtons;